<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-between">
    <div>
      <div class="bg-green-900 px-4 py-3 flex items-center justify-between shadow-md">
        <h1 class="text-white text-3xl font-bold">amazon</h1>
      </div>

      <div class="max-w-md mx-auto mt-8 px-4">
        <h1 class="text-2xl font-semibold mb-4 text-gray-800">Welcome</h1>

        <div class="bg-white shadow-md rounded-lg overflow-hidden border border-gray-200 pb-6">
          <div class="flex items-center bg-gray-100 py-3 px-4 border-b border-gray-200">
            <input
              type="radio"
              class="w-5 h-5 text-green-600 focus:ring-green-500 mr-3"
              value="sign_up"
              v-model="selectedPAge"
              @change="redirectToPage"
              id="radio_sign_up"
            />
            <label for="radio_sign_up" class="font-semibold cursor-pointer text-gray-700">
              Create account <span class="font-normal text-sm text-gray-500 ml-1">New to Amazon?</span>
            </label>
          </div>

          <div class="px-6 pt-4 space-y-4">
            <div>
              <label class="block font-semibold mb-1 text-gray-700">First and last name</label>
              <input
                type="text"
                class="border border-gray-300 rounded-md w-full h-11 px-3 focus:outline-none focus:border-green-600"
                v-model="model.user.user_name"
              />
            </div>

            <div>
              <label class="block font-semibold mb-1 text-gray-700">Email</label>
              <input
                type="text"
                class="border border-gray-300 rounded-md w-full h-11 px-3 focus:outline-none focus:border-green-600"
                v-model="model.user.email"
              />
            </div>

            <div>
              <label class="block font-semibold mb-1 text-gray-700">Create a password</label>
              <input
                type="text"
                class="border border-gray-300 rounded-md w-full h-11 px-3 focus:outline-none focus:border-green-600"
                v-model="model.user.password"
              />
            </div>

            <div class="flex items-center gap-2">
              <input
                type="checkbox"
                checked
                class="w-5 h-5 text-green-600 focus:ring-green-500 rounded"
                id="show_pwd"
              />
              <label for="show_pwd" class="font-semibold text-gray-700 cursor-pointer">Show password</label>
            </div>

            <div>
              <span class="block font-semibold mb-1 text-gray-700">Sex</span>
              <div class="flex items-center gap-4">
                <label class="flex items-center gap-1 cursor-pointer">
                  <input type="radio" value="Female" name="sex" class="w-4 h-4 text-green-600" v-model="selectSex">
                  Female
                </label>
                <label class="flex items-center gap-1 cursor-pointer">
                  <input type="radio" value="Male" name="sex" class="w-4 h-4 text-green-600" v-model="selectSex">
                  Male
                </label>
              </div>
            </div>

            <div>
              <label class="block font-semibold mb-1 text-gray-700">Upload Your Photo</label>
              <input
                type="file"
                class="border border-gray-300 rounded-md w-full h-11 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-gray-100 file:text-gray-700 hover:file:bg-gray-200 cursor-pointer"
                @change="handlephoto"
              />
            </div>

            <div class="text-center pt-2">
              <button
                :disabled="isLoading"
                class="bg-yellow-400 hover:bg-yellow-500 disabled:opacity-50 text-gray-900 font-semibold w-full py-3 rounded-md shadow-sm transition-all duration-150 flex items-center justify-center gap-2"
                @click="registerUser"
              >
                <span v-if="isLoading" class="animate-spin inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full"></span>
                <span>{{ isLoading ? 'Creating Account...' : 'Continue' }}</span>
              </button>
            </div>

            <div class="text-xs text-gray-600 font-medium pt-2 border-b border-gray-200 pb-4">
              By continuing you agree to Amazon's
              <a href="" class="underline text-blue-700 hover:text-blue-800">Conditions of Use</a>
              and
              <a href="" class="underline text-blue-700 hover:text-blue-800">Privacy Notice.</a>
            </div>

            <div class="pt-2">
              <p class="font-semibold text-sm text-gray-700">Buying for work?</p>
              <a href="" class="text-blue-700 hover:text-blue-800 hover:underline text-sm font-semibold">
                Create a free business account
              </a>
            </div>
          </div>

          <div class="flex items-center bg-gray-100 py-3 px-4 border-t border-gray-200 mt-4">
            <input
              type="radio"
              class="w-5 h-5 text-green-600 focus:ring-green-500 mr-3"
              value="sign_in"
              v-model="selectedPAge"
              @change="redirectToPage"
              id="radio_sign_in"
            />
            <label for="radio_sign_in" class="font-semibold cursor-pointer text-gray-700">
              Sign in <span class="font-normal text-sm text-gray-500 ml-1">Already a customer?</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="bg-gray-900 text-white pt-10 pb-10 mt-10">
      <div class="max-w-md mx-auto px-4">
        <div class="flex justify-between text-sm flex-wrap gap-4 border-b border-gray-800 pb-6 mb-6">
          <div class="hover:underline cursor-pointer"><i class="fa-solid fa-globe mr-1"></i> English</div>
          <div class="hover:underline cursor-pointer">$ USD - US. Dollar</div>
          <div class="hover:underline cursor-pointer flex items-center gap-1">
            <img src="/united.jpg" alt="" class="w-6 h-4 object-cover" /> United States
          </div>
        </div>

        <div class="flex justify-between text-xs text-gray-400 flex-wrap gap-3 mb-6">
          <a href="" class="hover:underline">Conditions of Use</a>
          <a href="" class="hover:underline">Privacy Notice</a>
          <a href="" class="hover:underline">Consumer Health Data Privacy Disclosure</a>
        </div>

        <div class="text-center text-xs text-gray-400 mb-2">
          Your Ads Privacy Choices <input type="checkbox" class="ml-1 align-middle" />
        </div>
        <div class="text-center text-xs text-gray-500">
          &copy;1996-2026, Amazon.com, Inc. or its affiliates
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data(){
    return{
      selectedPAge:'sign_up',
      selectSex:'',
      isLoading: false,
      model:{
        user:{
          user_name:'',
          email:'',
          password:'',
          sex:'',
          photo:''
        }
      }
    }
  },
  methods:{
    async registerUser(){
      if (this.isLoading) return;
      this.isLoading = true;
      if(this.selectSex === 'Female'){
        this.model.user.sex = 'Female'
      }
      else if(this.selectSex === 'Male'){
        this.model.user.sex = 'Male'
      }
      const formData = new FormData()
      formData.append('user_name',this.model.user.user_name)
      formData.append('email',this.model.user.email)
      formData.append('password',this.model.user.password)
      formData.append('sex',this.model.user.sex)
      formData.append('photo',this.model.user.photo)
      try {
        const res = await axios.post('https://ecommerce-api.kalkidan.net/api/user',formData,{
          headers:{
            'Content-Type':'multipart/form-data'
          }
        });
        console.log(res.data)
        this.$router.push('/Signin');
      } catch (err) {
        console.error(err);
        alert('Registration failed. Please check inputs and try again.');
      } finally {
        this.isLoading = false;
      }
    },
    handlephoto(event) {
      const file = event.target.files[0]
      if (file) {
        this.model.user.photo = event.target.files[0]
      }
    },
    redirectToPage() {
      if (this.selectedPAge === "sign_in") {
        this.$router.push("/Signin");
      } else if (this.selectedPAge === "sign_up") {
        this.$router.push("/Signup");
      }
    },
  }
}
</script>

<style scoped>
</style>
